import { audio_engine } from "../core/AudioEngine";

export const updateEffectVolume = (vol: number) => {
  audio_engine.effect_volume = vol;
  audio_engine.sound_effects.map((s) => s.updateVolume());
};

export const updateMusicVolume = (vol: number) => {
  audio_engine.music_volume = vol;
  audio_engine.onride_sound?.updateVolume();
  audio_engine.region_sounds.map((s) => s.updateVolume());
  //audio_engine.sound_effects.map((s) => s.updateVolume());
};
